/** Тексты пространства «config». Ключи именуются по смыслу, а не по месту. */
export const config = {
  /* Общее у всех выключателей: карточка у них одна, и подписи вокруг значения
     тоже одни. Своё — только в `flag`. */
  valueDefault: 'умолчание',
  updatedAt: 'Последнее изменение: {{date}}',
  error: 'Не переключили',

  flag: {
    maintenance: {
      title: 'Технические работы',

      state: {
        on: 'режим включён',
        off: 'приложение работает как обычно',
      },

      hint: 'В этом режиме запись закрыта для всех, кроме суперадмина: игрок не отправит анкету, модератор не примет решение. Чтение работает как обычно — реестр и база внешек остаются открытыми, пустого экрана никто не увидит.',

      action: {
        enable: 'Включить режим работ',
        disable: 'Выключить режим работ',
      },

      confirm: {
        enableTitle: 'Включить режим работ?',
        disableTitle: 'Выключить режим работ?',
        enableText:
          'Запись закроется для игроков и модераторов. На вас режим не действует — суперадмин проходит мимо проверки, поэтому увидеть приложение в режиме работ получится только с другого аккаунта. Чтение продолжит работать у всех. Не забудьте выключить, когда закончите.',
        disableText: 'Запись снова откроется для всех.',
        enable: 'Включить',
        disable: 'Выключить',
      },
    },

    selfRegistration: {
      title: 'Самостоятельная запись',

      state: {
        on: 'запись открыта',
        off: 'участников добавляет администратор',
      },

      hint: 'Пока запись открыта, любой, кто открыл приложение, добавляет себя в список участников сам: ролью игрока и под именем своей страницы ВКонтакте. Заявки и подтверждения при этом нет. Тому, у кого доступ снят, это не поможет — вернуть доступ может только администратор.',

      action: {
        enable: 'Открыть запись',
        disable: 'Закрыть запись',
      },

      confirm: {
        enableTitle: 'Открыть запись?',
        disableTitle: 'Закрыть запись?',
        enableText:
          'Вступить сможет каждый, кто откроет приложение, — вручную добавлять больше никого не придётся, но и отбирать будет некому.',
        disableText:
          'Вступить самостоятельно станет нельзя. Те, кто уже записался, останутся в списке — снимать доступ придётся руками.',
        enable: 'Открыть',
        disable: 'Закрыть',
      },
    },
  },
} as const;
